<template>
  <v-layout class="login" align-center>
    <v-flex xs12 sm8 md6 lg4 offset-sm2 offset-md3 offset-lg4>
      <v-card class="elevation-3" xs12 sm8 md4>
        <v-layout align-center justify-center>
          <img src="../assets/largeicon.png" alt="logo" class="logo"/>
        </v-layout>

        <v-card-text>
          <v-form
            ref="form"
            lazy-validation
            >
            <v-text-field prepend-icon="person"
              name="login"
              label="Login"
              type="text"
              v-model="email"
              :rules="[rules.required]"
              ></v-text-field>

            <v-text-field prepend-icon="lock"
              name="password"
              label="Password"
              type="password"
              v-model="password"
              @keyup.enter="login()"
              :rules="[rules.required]"
              ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn block @click="login()" :disabled="!(email && password)"> Login </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-layout row align-center justify-center>
            <v-btn flat to="/forgot-password"> Reset your password </v-btn>
          </v-layout>
          <v-layout row align-center justify-center>
            <v-btn flat color="success" to="/register"> Register a new account </v-btn>
          </v-layout>
          <v-layout row align-center justify-center class="grey--text">
            <v-btn flat small href="/jargon/policy" target="jargon" class="grey--text caption mb-0">Policies</v-btn>|
            <v-btn flat small href="/jargon/pricing" target="jargon" class="grey--text caption mb-0">Pricing</v-btn>|
            <v-btn flat small href="/jargon/contact" target="jargon" class="grey--text caption mb-0">Contact us</v-btn>
          </v-layout>
        </v-card-text>
        <v-alert :value="error" type="warning" class="mt-3"> {{ error }} </v-alert>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import authentication from '@/utilities/authentication'
  import authService from '@/services/authentication'

  export default {
    name: 'login',
    data () {
      return {
        auth: authentication,
        error: null,
        email: '',
        password: '',
        rules: {
          required: v => !!v || 'Required'
        }
      }
    },

    computed: {
    },

    methods: {
      login () {
        if (this.$refs.form.validate()) {
          authService.login(
            (data) => {
              let preferredStart = '/'
              if (this.auth.preferences().project_id) {
                if (this.auth.preferences().project_id === 'activity') {
                  preferredStart = '/watches'
                } else {
                  preferredStart = '/projects/' + this.auth.preferences().project_id
                }
              }
              this.$router.replace(this.$route.query.redirect || preferredStart)
            },
            (err) => {
              console.log(err)
              if (err.response) {
                if (err.response.status === 404) {
                  this.error = 'Login failed.'
                } else if (err.response.status === 401) {
                  this.error = err.response.data.errors[0]
                } else {
                  this.error = 'We have encountered a problem while trying to log you in (' + err.response.statusText + ').'
                }
              } else {
                this.error = 'The system is currently unreachable. ' + err.message
              }
            },
            this.email,
            this.password
          )
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .theme--light.v-card{
    padding: 15px;
  }
  .theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat){
    background-color: #1976d2;
    color: #fff;
  }
  .v-btn.v-btn--flat.v-btn--router.theme--light.info--text{
  width: 100%;
  padding: 0;
  text-align: center;
  margin: 6px 0;
  }
  .v-btn__content{
    white-space: normal;
  }
  .v-btn--active:before, .v-btn:focus:before, .v-btn:hover:before{
    background-color: #fff;
    box-shadow: 0 3px 3px -2px rgba(0,0,0,.6),0 3px 4px 0 rgba(0,0,0,.48),0 1px 8px 0 rgba(0,0,0,.44);
  }
  .warning{
    background-color: #ffeb3b!important;
  }
  .v-alert{
    color: #212121;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue